import * as React from 'react'
import { SVGProps } from 'react'
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M21.515 15.94 22 14h-3.287c-.627 0-.94 0-1.224.086a2.001 2.001 0 0 0-.689.369c-.229.188-.403.449-.75.97l-.1.15c-.347.521-.521.782-.75.97a2.001 2.001 0 0 1-.69.369c-.283.086-.596.086-1.223.086h-2.574c-.627 0-.94 0-1.224-.086a2 2 0 0 1-.689-.369c-.229-.189-.403-.449-.75-.97l-.1-.15c-.347-.521-.521-.782-.75-.97a2 2 0 0 0-.69-.369C6.228 14 5.915 14 5.288 14H2l.485 1.94c.542 2.167.812 3.25 1.416 4.057a5 5 0 0 0 2.066 1.613c.93.39 2.046.39 4.28.39h3.507c2.233 0 3.35 0 4.279-.39a5 5 0 0 0 2.065-1.613c.604-.807.875-1.89 1.417-4.057Z"
      opacity={0.12}
    />
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M2.5 14h2.787c.626 0 .94 0 1.224.086a2 2 0 0 1 .688.369c.23.188.404.449.75.97l.1.15c.348.521.522.782.751.97a2 2 0 0 0 .689.369c.284.086.597.086 1.223.086h2.575c.626 0 .94 0 1.224-.086a2 2 0 0 0 .688-.369c.23-.189.403-.449.75-.97l.1-.15c.348-.521.522-.782.751-.97.203-.167.438-.292.689-.369.284-.086.597-.086 1.223-.086H21.5M9 7h6m-5 4h4M3.485 8.06l-.616 2.464c-.14.562-.21.843-.267 1.123a12 12 0 0 0 0 4.706c.056.28.126.561.267 1.123v0c.175.7.262 1.05.38 1.35a5 5 0 0 0 4.012 3.133c.32.041.68.041 1.402.041h6.674c.721 0 1.082 0 1.402-.041a5 5 0 0 0 4.012-3.133c.117-.3.205-.65.38-1.35v0c.14-.562.21-.843.267-1.123a12 12 0 0 0 0-4.706c-.056-.28-.127-.561-.267-1.123l-.616-2.464c-.542-2.167-.813-3.25-1.416-4.057a5 5 0 0 0-2.066-1.613C16.103 2 14.987 2 12.753 2h-1.507c-2.233 0-3.35 0-4.279.39a5 5 0 0 0-2.065 1.613c-.604.807-.875 1.89-1.417 4.057Z"
    />
  </svg>
)
export default SvgComponent
